<template><article><h1>使用插槽</h1>
<div class="tip custom-block"><p class="custom-block-title">TIP</p>
<p>例子中使用的 <code v-pre>v-slot:</code> 或符号 <code v-pre>#</code> 都是基于 vue 版本 2.6.0 以上的，低版本可以使用 <code v-pre>slot</code> 和 <code v-pre>slot-scoped</code> 代替，具体请看官方文档</p>
</div>
<h3 id="滑块插槽"><a class="header-anchor" href="#滑块插槽" aria-hidden="true">#</a> 滑块插槽</h3>
<p><example :value="example1"></example></p>
<h3 id="工具提示插槽"><a class="header-anchor" href="#工具提示插槽" aria-hidden="true">#</a> 工具提示插槽</h3>
<p><example :value="example2"></example></p>
<h3 id="标签插槽"><a class="header-anchor" href="#标签插槽" aria-hidden="true">#</a> 标签插槽</h3>
<p><example :value="example3"></example></p>
<h3 id="标记插槽"><a class="header-anchor" href="#标记插槽" aria-hidden="true">#</a> 标记插槽</h3>
<p><example :value="example4"></example></p>
<h3 id="进度条插槽"><a class="header-anchor" href="#进度条插槽" aria-hidden="true">#</a> 进度条插槽</h3>
<p><example :value="example5"></example></p>
</article></template>

<script>
  import examples from '@/examples/components-slots.ts'
  export default {
    data () {
      return {
        ...examples
      }
    }
  }
</script>